export default [
    {
        path: '',
        component: () => import(/* webpackChunkName: "js/configuration/basic/index" */ '@views/configuration/basic/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: 'basic',
        component: () => import(/* webpackChunkName: "js/configuration/basic/index" */ '@views/configuration/basic/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: 'social',
        component: () => import(/* webpackChunkName: "js/configuration/social/index" */ '@views/configuration/social/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: 'system',
        component: () => import(/* webpackChunkName: "js/configuration/system/index" */ '@views/configuration/system/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: 'mail',
        component: () => import(/* webpackChunkName: "js/configuration/mail/index" */ '@views/configuration/mail/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: 'role',
        component: () => import(/* webpackChunkName: "js/configuration/role/index" */ '@views/configuration/role/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: 'permission',
        component: () => import(/* webpackChunkName: "js/configuration/permission/index" */ '@views/configuration/permission/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: '/configuration/permission/:module',
        component: () => import(/* webpackChunkName: "js/configuration/permission/module" */ '@views/configuration/permission/module'),
        meta: { menu: 'configuration'}
    },
    {
        path: '/configuration/authentication',
        component: () => import(/* webpackChunkName: "js/configuration/authentication/index" */ '@views/configuration/authentication/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: '/configuration/sms',
        component: () => import(/* webpackChunkName: "js/configuration/sms/index" */ '@views/configuration/sms/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: '/configuration/whatsapp',
        component: () => import(/* webpackChunkName: "js/configuration/whatsapp/index" */ '@views/configuration/whatsapp/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: '/configuration/message_template',
        component: () => import(/* webpackChunkName: "js/configuration/messageTemplate/index" */ '@views/configuration/messageTemplate/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: '/configuration/message_template/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/messageTemplate/index" */ '@views/configuration/messageTemplate/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: '/configuration/payment/gateway',
        component: () => import(/* webpackChunkName: "js/configuration/paymentGateway/index" */ '@views/configuration/payment-gateway/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: '/configuration/locale',
        component: () => import(/* webpackChunkName: "js/configuration/locale/index" */ '@views/configuration/locale/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: '/configuration/locale/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/locale/index" */ '@views/configuration/locale/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: '/configuration/locale/:locale',
        component: () => import(/* webpackChunkName: "js/configuration/locale/show" */ '@views/configuration/locale/show'),
        meta: { menu: 'configuration'}
    },
    {
        path: '/configuration/locale/:locale/:module',
        component: () => import(/* webpackChunkName: "js/configuration/locale/show" */ '@views/configuration/locale/show'),
        meta: { menu: 'configuration'}
    },
    {
        path: '/configuration/menu',
        component: () => import(/* webpackChunkName: "js/configuration/menu/index" */ '@views/configuration/menu/index'),
        meta: { menu: 'configuration'}
    },
    {
        path: '/configuration/module',
        component: () => import(/* webpackChunkName: "js/configuration/module/index" */ '@views/configuration/module/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/academic/course/group',
        component: () => import(/* webpackChunkName: "js/configuration/academic/courseGroup/index" */ '@views/configuration/academic/course-group/index'),
    },
    {
        path: '/configuration/academic/course/group/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/academic/courseGroup/index" */ '@views/configuration/academic/course-group/index'),
    },
    {
        path: '/configuration/academic/institute',
        component: () => import(/* webpackChunkName: "js/configuration/academic/institute/index" */ '@views/configuration/academic/institute/index'),
    },
    {
        path: '/configuration/academic/institute/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/academic/institute/index" */ '@views/configuration/academic/institute/index'),
    },
    {
        path: '/configuration/academic/certificate/template',
        component: () => import(/* webpackChunkName: "js/configuration/academic/certificateTemplate/index" */ '@views/configuration/academic/certificate-template/index'),
    },
    {
        path: '/configuration/academic/certificate/template/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/academic/certificateTemplate/index" */ '@views/configuration/academic/certificate-template/index'),
    },
    {
        path: '/configuration/academic/print/template',
        component: () => import(/* webpackChunkName: "js/configuration/academic/print-templace/index" */ '@views/configuration/academic/print-templace/index'),
    },
    {
        path: '/configuration/academic/print/template/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/academic/print-templace/index" */ '@views/configuration/academic/print-templace/index'),
    },
    {
        path: '/configuration/academic/marksheet/template',
        component: () => import(/* webpackChunkName: "js/configuration/academic/marksheet-template/index" */ '@views/configuration/academic/marksheet-template/index'),
    },
    {
        path: '/configuration/academic/marksheet/template/create',
        component: () => import(/* webpackChunkName: "js/configuration/academic/marksheet-template/create" */ '@views/configuration/academic/marksheet-template/create'),
    },
    {
        path: '/configuration/academic/marksheet/template/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/academic/marksheet-template/index" */ '@views/configuration/academic/marksheet-template/index'),
    },
    {
        path: '/configuration/academic/id-card/template',
        component: () => import(/* webpackChunkName: "js/configuration/academic/idCardTemplate/index" */ '@views/configuration/academic/id-card-template/index'),
    },
    {
        path: '/configuration/academic/id-card/template/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/academic/idCardTemplate/index" */ '@views/configuration/academic/id-card-template/index'),
    },
    {
        path: '/configuration/academic/id-card/template/:id',
        component: () => import(/* webpackChunkName: "js/configuration/academic/idCardTemplate/show" */ '@views/configuration/academic/id-card-template/show'),
    },
    {
        path: '/configuration/misc/caste',
        component: () => import(/* webpackChunkName: "js/configuration/misc/caste/index" */ '@views/configuration/misc/caste/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/misc/caste/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/misc/caste/index" */ '@views/configuration/misc/caste/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/misc/religion',
        component: () => import(/* webpackChunkName: "js/configuration/misc/religion/index" */ '@views/configuration/misc/religion/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/misc/religion/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/misc/religion/index" */ '@views/configuration/misc/religion/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/misc/category',
        component: () => import(/* webpackChunkName: "js/configuration/misc/category/index" */ '@views/configuration/misc/category/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/misc/category/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/misc/category/index" */ '@views/configuration/misc/category/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/misc/blood/group',
        component: () => import(/* webpackChunkName: "js/configuration/misc/bloodGroup/index" */ '@views/configuration/misc/blood-group/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/misc/blood/group/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/misc/bloodGroup/index" */ '@views/configuration/misc/blood-group/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/misc/disability/type',
        component: () => import(/* webpackChunkName: "js/configuration/misc/disabilityType/index" */ '@views/configuration/misc/disability-type/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/misc/disability/type/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/misc/disabilityType/index" */ '@views/configuration/misc/disability-type/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/misc/medium/instruction',
        component: () => import(/* webpackChunkName: "js/configuration/misc/mediumInstruction/index" */ '@views/configuration/misc/medium-instruction/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/misc/medium/instruction/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/misc/mediumInstruction/index" */ '@views/configuration/misc/medium-instruction/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/finance/transaction/category',
        component: () => import(/* webpackChunkName: "js/configuration/finance/transaction/category/index" */ '@views/configuration/finance/transaction/category/index'),
    },
    {
        path: '/configuration/finance/transaction/category/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/finance/transaction/category/index" */ '@views/configuration/finance/transaction/category/index'),
    },
    {
        path: '/configuration/finance/payment/method',
        component: () => import(/* webpackChunkName: "js/configuration/finance/transaction/paymentMethod/index" */ '@views/configuration/finance/transaction/payment-method/index'),
    },
    {
        path: '/configuration/finance/payment/method/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/finance/transaction/paymentMethod/index" */ '@views/configuration/finance/transaction/payment-method/index'),
    },
    {
        path: '/configuration/frontend/index',
        component: () => import(/* webpackChunkName: "js/configuration/frontend/index" */ '@views/configuration/frontend/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/student',
        component: () => import(/* webpackChunkName: "js/configuration/student/index" */ '@views/configuration/student/index'),
    },
    {
        path: '/configuration/student/document/type',
        component: () => import(/* webpackChunkName: "js/configuration/student/documentType/index" */ '@views/configuration/student/document-type/index'),
    },
    {
        path: '/configuration/student/document/type/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/student/documentType/index" */ '@views/configuration/student/document-type/index'),
    },
    {
        path: '/configuration/student/group',
        component: () => import(/* webpackChunkName: "js/configuration/student/studentGroup/index" */ '@views/configuration/student/student-group/index'),
    },
    {
        path: '/configuration/student/group/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/student/studentGroup/index" */ '@views/configuration/student/student-group/index'),
    },
    {
        path: 'student/house',
        component: () => import(/* webpackChunkName: "js/configuration/student/house/index" */ '@views/configuration/student/house/index'),
    },
    {
        path: 'student/house/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/student/house/index" */ '@views/configuration/student/house/index'),
    },
    {
        path: 'student/question',
        component: () => import(/* webpackChunkName: "js/configuration/student/question/index" */ '@views/configuration/student/question/index'),
    },
    {
        path: 'student/question/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/student/question/index" */ '@views/configuration/student/question/index'),
    },
    {
        path: 'student/favorites',
        component: () => import(/* webpackChunkName: "js/configuration/student/favorites/index" */ '@views/configuration/student/favorites/index'),
    },
    {
        path: 'student/favorites/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/student/favorites/index" */ '@views/configuration/student/favorites/index'),
    },
    {
        path: '/configuration/exam/term',
        component: () => import(/* webpackChunkName: "js/configuration/exam/term/index" */ '@views/configuration/exam/term/index'),
    },
    {
        path: '/configuration/exam/term/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/exam/term/index" */ '@views/configuration/exam/term/index'),
    },
    {
        path: '/configuration/exam/assessment',
        component: () => import(/* webpackChunkName: "js/configuration/exam/assessment/index" */ '@views/configuration/exam/assessment/index'),
    },
    {
        path: '/configuration/exam/assessment/create',
        component: () => import(/* webpackChunkName: "js/configuration/exam/assessment/create" */ '@views/configuration/exam/assessment/create'),
    },
    {
        path: '/configuration/exam/assessment/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/exam/assessment/index" */ '@views/configuration/exam/assessment/index'),
    },
    {
        path: '/configuration/exam/observation',
        component: () => import(/* webpackChunkName: "js/configuration/exam/observation/index" */ '@views/configuration/exam/observation/index'),
    },
    {
        path: '/configuration/exam/observation/create',
        component: () => import(/* webpackChunkName: "js/configuration/exam/observation/create" */ '@views/configuration/exam/observation/create'),
    },
    {
        path: '/configuration/exam/observation/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/exam/observation/index" */ '@views/configuration/exam/observation/index'),
    },
    {
        path: '/configuration/exam/grade',
        component: () => import(/* webpackChunkName: "js/configuration/exam/grade/index" */ '@views/configuration/exam/grade/index'),
    },
    {
        path: '/configuration/exam/grade/create',
        component: () => import(/* webpackChunkName: "js/configuration/exam/grade/create" */ '@views/configuration/exam/grade/create'),
    },
    {
        path: '/configuration/exam/grade/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/exam/grade/index" */ '@views/configuration/exam/grade/index'),
    },
    {
        path: '/configuration/exam/remark-rule',
        component: () => import(/* webpackChunkName: "js/configuration/exam/remark-rule" */ '@views/configuration/exam/remark-rule/index'),
    },
    {
        path: '/configuration/exam/result-division-rule',
        component: () => import(/* webpackChunkName: "js/configuration/exam/result-division-rule" */ '@views/configuration/exam/result-division-rule/index'),
    },

    {
        path: '/configuration/exam/authority',
        component: () => import(/* webpackChunkName: "js/configuration/exam/authority/index" */ '@views/configuration/exam/authority/index'),
    },
    {
        path: '/configuration/exam/authority/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/exam/authority/index" */ '@views/configuration/exam/authority/index'),
    },
    {
        path: '/configuration/exam/marksheet/template',
        component: () => import(/* webpackChunkName: "js/configuration/exam/marksheet-template/index" */ '@views/configuration/academic/marksheet-template/index'),
    },
    {
        path: '/configuration/exam/marksheet/template/create',
        component: () => import(/* webpackChunkName: "js/configuration/exam/marksheet-template/create" */ '@views/configuration/academic/marksheet-template/create'),
    },
    {
        path: '/configuration/exam/marksheet/template/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/exam/marksheet-template/index" */ '@views/configuration/academic/marksheet-template/index'),
    },

    {
        path: '/configuration/employee/group',
        component: () => import(/* webpackChunkName: "js/configuration/employee/employeeGroup/index" */ '@views/configuration/employee/employee-group/index'),
    },
    {
        path: '/configuration/employee/group/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/employee/employeeGroup/index" */ '@views/configuration/employee/employee-group/index'),
    },
    {
        path: '/configuration/employee',
        component: () => import(/* webpackChunkName: "js/configuration/employee/index" */ '@views/configuration/employee/index'),
    },
    {
        path: '/configuration/employee/document/type',
        component: () => import(/* webpackChunkName: "js/configuration/employee/documentType/index" */ '@views/configuration/employee/document-type/index'),
    },
    {
        path: '/configuration/employee/document/type/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/employee/documentType/index" */ '@views/configuration/employee/document-type/index'),
    },
    {
        path: '/configuration/employee/leave/type',
        component: () => import(/* webpackChunkName: "js/configuration/employee/leaveType/index" */ '@views/configuration/employee/leave-type/index'),
    },
    {
        path: '/configuration/employee/leave/type/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/employee/leaveType/index" */ '@views/configuration/employee/leave-type/index'),
    },
    {
        path: '/configuration/employee/attendance/type',
        component: () => import(/* webpackChunkName: "js/configuration/employee/attendanceType/index" */ '@views/configuration/employee/attendance-type/index'),
    },
    {
        path: '/configuration/employee/attendance/type/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/employee/attendanceType/index" */ '@views/configuration/employee/attendance-type/index'),
    },
    {
        path: '/configuration/employee/pay/head',
        component: () => import(/* webpackChunkName: "js/configuration/employee/payHead/index" */ '@views/configuration/employee/pay-head/index'),
    },
    {
        path: '/configuration/employee/pay/head/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/employee/payHead/index" */ '@views/configuration/employee/pay-head/index'),
    },
    {
        path: '/configuration/employee/category',
        component: () => import(/* webpackChunkName: "js/configuration/employee/category/index" */ '@views/configuration/employee/category/index'),
    },
    {
        path: '/configuration/employee/category/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/employee/category/index" */ '@views/configuration/employee/category/index'),
    },
    {
        path: '/configuration/employee/department',
        component: () => import(/* webpackChunkName: "js/configuration/employee/department/index" */ '@views/configuration/employee/department/index'),
    },
    {
        path: '/configuration/employee/department/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/employee/department/index" */ '@views/configuration/employee/department/index'),
    },
    {
        path: '/configuration/employee/designation',
        component: () => import(/* webpackChunkName: "js/configuration/employee/designation/index" */ '@views/configuration/employee/designation/index'),
    },
    {
        path: '/configuration/employee/designation/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/employee/designation/index" */ '@views/configuration/employee/designation/index'),
    },
    {
        path: '/configuration/transport/vehicle/document/type',
        component: () => import(/* webpackChunkName: "js/configuration/transport/vehicle/documentType/index" */ '@views/configuration/transport/vehicle/document-type/index'),
    },
    {
        path: '/configuration/transport/vehicle/document/type/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/transport/vehicle/documentType/index" */ '@views/configuration/transport/vehicle/document-type/index'),
    },
    {
        path: '/configuration/transport/vehicle/service/center',
        component: () => import(/* webpackChunkName: "js/configuration/transport/vehicle/serviceCenter/index" */ '@views/configuration/transport/vehicle/service-center/index'),
    },
    {
        path: '/configuration/transport/vehicle/service/center/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/transport/vehicle/serviceCenter/index" */ '@views/configuration/transport/vehicle/service-center/index'),
    },
    {
        path: '/configuration/transport/vehicle/fuel/type',
        component: () => import(/* webpackChunkName: "js/configuration/transport/vehicle/fuelType/index" */ '@views/configuration/transport/vehicle/fuel-type/index'),
    },
    {
        path: '/configuration/transport/vehicle/fuel/type/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/transport/vehicle/fuelType/index" */ '@views/configuration/transport/vehicle/fuel-type/index'),
    },
    {
        path: '/configuration/asset/building',
        component: () => import(/* webpackChunkName: "js/configuration/asset/building/index" */ '@views/configuration/asset/building/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/asset/building/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/asset/building/index" */ '@views/configuration/asset/building/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/asset/room',
        component: () => import(/* webpackChunkName: "js/configuration/asset/room/index" */ '@views/configuration/asset/room/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/asset/room/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/asset/room/index" */ '@views/configuration/asset/room/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/library',
        component: () => import(/* webpackChunkName: "js/configuration/library/index" */ '@views/configuration/library/index')
    },
    {
        path: '/configuration/library/book/author',
        component: () => import(/* webpackChunkName: "js/configuration/library/bookAuthor/index" */ '@views/configuration/library/book-author/index')
    },
    {
        path: '/configuration/library/book/author/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/library/bookAuthor/index" */ '@views/configuration/library/book-author/index')
    },
    {
        path: '/configuration/library/book/language',
        component: () => import(/* webpackChunkName: "js/configuration/library/bookLanguage/index" */ '@views/configuration/library/book-language/index')
    },
    {
        path: '/configuration/library/book/language/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/library/bookLanguage/index" */ '@views/configuration/library/book-language/index')
    },
    {
        path: '/configuration/library/book/topic',
        component: () => import(/* webpackChunkName: "js/configuration/library/bookTopic/index" */ '@views/configuration/library/book-topic/index')
    },
    {
        path: '/configuration/library/book/topic/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/library/bookTopic/index" */ '@views/configuration/library/book-topic/index')
    },
    {
        path: '/configuration/library/book/publisher',
        component: () => import(/* webpackChunkName: "js/configuration/library/bookPublisher/index" */ '@views/configuration/library/book-publisher/index')
    },
    {
        path: '/configuration/library/book/publisher/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/library/bookPublisher/index" */ '@views/configuration/library/book-publisher/index')
    },
    {
        path: '/configuration/library/book/condition',
        component: () => import(/* webpackChunkName: "js/configuration/library/bookCondition/index" */ '@views/configuration/library/book-condition/index')
    },
    {
        path: '/configuration/library/book/condition/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/library/bookCondition/index" */ '@views/configuration/library/book-condition/index')
    },
    {
        path: '/configuration/calendar/event/type',
        component: () => import(/* webpackChunkName: "js/configuration/calendar/eventType/index" */ '@views/configuration/calendar/event-type/index')
    },
    {
        path: '/configuration/calendar/event/type/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/calendar/eventType/index" */ '@views/configuration/calendar/event-type/index')
    },
    {
        path: '/configuration/calendar/celebration-template',
        component: () => import(/* webpackChunkName: "js/configuration/calendar/celebrationTemplate/index" */ '@views/configuration/calendar/celebrationTemplate/index')
    },
    {
        path: '/configuration/calendar/celebration-template/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/calendar/celebrationTemplate/index" */ '@views/configuration/calendar/celebrationTemplate/index')
    },
    {
        path: '/configuration/post/article/type',
        component: () => import(/* webpackChunkName: "js/configuration/post/articleType/index" */ '@views/configuration/post/article-type/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/post/article/type/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/post/articleType/index" */ '@views/configuration/post/article-type/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/reception/enquiry/type',
        component: () => import(/* webpackChunkName: "js/configuration/reception/enquiryType/index" */ '@views/configuration/reception/enquiry-type/index'),
    },
    {
        path: '/configuration/reception/enquiry/type/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/reception/enquiryType/index" */ '@views/configuration/reception/enquiry-type/index'),
    },
    {
        path: '/configuration/reception/enquiry/source',
        component: () => import(/* webpackChunkName: "js/configuration/reception/enquirySource/index" */ '@views/configuration/reception/enquiry-source/index'),
    },
    {
        path: '/configuration/reception/enquiry/source/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/reception/enquirySource/index" */ '@views/configuration/reception/enquiry-source/index'),
    },
    {
        path: '/configuration/reception/complaint/type',
        component: () => import(/* webpackChunkName: "js/configuration/reception/complaintType/index" */ '@views/configuration/reception/complaint-type/index'),
    },
    {
        path: '/configuration/reception/complaint/type/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/reception/complaintType/index" */ '@views/configuration/reception/complaint-type/index'),
    },
    {
        path: '/configuration/reception/visiting/purpose',
        component: () => import(/* webpackChunkName: "js/configuration/reception/visitingPurpose/index" */ '@views/configuration/reception/visiting-purpose/index'),
    },
    {
        path: '/configuration/reception/visiting/purpose/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/reception/visitingPurpose/index" */ '@views/configuration/reception/visiting-purpose/index'),
    },
    {
        path: '/configuration/reception/calling/purpose',
        component: () => import(/* webpackChunkName: "js/configuration/reception/callingPurpose/index" */ '@views/configuration/reception/calling-purpose/index'),
    },
    {
        path: '/configuration/reception/calling/purpose/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/reception/callingPurpose/index" */ '@views/configuration/reception/calling-purpose/index'),
    },
    {
        path: '/configuration/custom-field',
        component: () => import(/* webpackChunkName: "js/configuration/customField/index" */ '@views/configuration/custom-field/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/custom-field',
        component: () => import(/* webpackChunkName: "js/configuration/customField/index" */ '@views/configuration/custom-field/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/custom-field/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/customField/index" */ '@views/configuration/custom-field/index'),
        meta: { menu: 'module-configuration'}
    },
    {
        path: '/configuration/hostel/category',
        component: () => import(/* webpackChunkName: "js/configuration/misc/category/index" */ '@views/configuration/hostel/category/index')
    },
    {
        path: '/configuration/hostel/category/:id/edit',
        component: () => import(/* webpackChunkName: "js/configuration/misc/category/index" */ '@views/configuration/hostel/category/index')
    }
]